import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';
import './Auth.scss';
import Form, { FormErrorInline, Label } from '../Form';
import { EmailInput } from '../Input';
import Button, { SubmitButton } from '../Button';
import { AuthAnalyticsEvents, SignInMethods } from '../../containers/AuthContainer/authSteps';
import AriaLiveRegion from '../AriaLiveRegion';

const CaptureEmailView = (props) => {
  const {
    onSubmit, onSignUp, event, error,
  } = props;

  useEffect(() => {
    event(AuthAnalyticsEvents.START_SIGN_IN, {
      method: SignInMethods.EMAIL_CODE,
    });
  }, []);

  return (
    <div className="AuthView">
      <TranslationProvider
        translationKey="onboarding.title_secondary"
      >
        <div className="AuthView__Text--light CaptureEmailViewTextDesc">
          Resy’s hospitality platform securely manages your account information and reservations.
        </div>
      </TranslationProvider>
      <TranslationProvider
        translationKey="onboarding.please_log_in"
      >
        <h2 className="AuthView__Headline CaptureEmailViewHeadline">
          Please log in:
        </h2>
      </TranslationProvider>
      <Form
        name="login_form"
        onSubmit={onSubmit}
        error={error}
      >
        {({
          onChange, errorData, errorKeys, processing,
        }) => (
          <div className="CaptureEmail">
            <AriaLiveRegion
              id="CaptureEmailForm__status"
            >
              {processing ? getTranslation({
                translationKey: 'communication_loading_message',
                fallback: 'Loading...',
              }) : ''}
            </AriaLiveRegion>
            <Label forInput="email" required>
              <TranslationProvider
                translationKey="email_address"
              >
                Email Address
              </TranslationProvider>
            </Label>
            <EmailInput
              id="email"
              ariaRequired
              onChange={onChange}
              errors={errorKeys}
              ariaDescribedby="error_email"
            />
            {errorData
              && errorData.em_address
              && <FormErrorInline id="error_email">{errorData.em_address}</FormErrorInline>}

            <TranslationProvider
              translationKey="onboarding.continue"
            >
              <SubmitButton
                className="EmailButton"
                data-testid="email-capture-button"
                processing={processing}
              >
                Continue
              </SubmitButton>
            </TranslationProvider>

          </div>
        )}
      </Form>
      <div className="AuthView__EmailCaptureDivider" role="separator" />
      <div className="AuthView__Footer">
        <TranslationProvider
          translationKey="onboarding.no_account"
        >
          <span>Don’t have an account?&nbsp;</span>
        </TranslationProvider>
        <TranslationProvider
          translationKey="signup"
        >
          <Button
            onClick={onSignUp}
            type="button"
            style={{ textTransform: 'capitalize' }}
            variant="link-inline"
            data-testid="sign-up-button"
          >
            Sign Up
          </Button>
        </TranslationProvider>
      </div>
    </div>
  );
};

CaptureEmailView.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired,
  event: PropTypes.func.isRequired,
  error: PropTypes.shape({
    serverError: PropTypes.bool,
    msg: PropTypes.string,
    keys: PropTypes.arrayOf(PropTypes.string),
  }),
};

CaptureEmailView.defaultProps = {
  error: {
    serverError: false,
    msg: '',
    keys: [],
  },
};

CaptureEmailView.displayName = 'CaptureEmailView';
export default CaptureEmailView;
